<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div id="popup-container">

  <h1 mat-dialog-title>Update Planning Market</h1>

  <div mat-dialog-content>
    <mat-label>Current Planning Market:</mat-label>
    <br/>
    <div class="current-value-input">
      {{ plngMkt.plngMkt }}
    </div>
    <div class="d-flex flex-column gap-8">
      <mat-label>Status:</mat-label>
      <mat-radio-group [(ngModel)]="updatedStatus" class="d-flex flex-column gap-8">
        <mat-radio-button [value]="0">Inactive</mat-radio-button>
        <mat-radio-button [value]="1">Active</mat-radio-button>
      </mat-radio-group>
    </div>
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>Select Subregion</mat-label>
      <mat-select [(ngModel)]="updatedSubregion">
        <mat-option *ngFor="let subregion of subregions"
                    [value]="subregion.subregionValue">{{ subregion.subregionValue }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <div id="actions-container">
      <button mat-stroked-button id="cancel-button" class="action-button" mat-dialog-close>Cancel</button>
      <button mat-raised-button color="primary" id="commit-button" class="action-button"
              [disabled]="updatedSubregion === plngMkt.subRegion && updatedStatus === plngMkt.active"
              (click)="commitChanges()">
        Change
      </button>
    </div>
  </div>
</div>
